<template>
  <div class="customer-list">
    <van-search v-model="keyword" show-action placeholder="请输入搜索关键词" @clear="handleClear" @search="handleSearch">
      <template #action>
        <div @click="handleSearch">搜索</div>
      </template>
    </van-search>
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="handleLoad">
      <van-cell @click="handleClick(item)" v-for="item in list" :key="item.name" is-link :title="item.name || ''"
        clickable />
    </van-list>
  </div>
</template>
<script>
import {
  getCustomerListAll,
} from "@/api/newApi.js";
import {getCustomerInfoPage} from "../../../api/customer";
export default {
  name: "customer-list",
  props: {
    userList: {
      type: Array,
      default: () => ([]),
    }
  },
  data: () => ({
    loading: false,
    list: [],
    finished: true,
    keyword: "",
    pageSize: 20,
    pageNo: 1,
  }),
  mounted () {
    this.id = this.$route.query.id;
    this.list = this.userList;
    if (this.list.length == 0) {
      this.getCustomerListAll()
    }
  },
  methods: {
    handleBack () {
      this.$router.back();
    },
    dayFormat (str) {
      str = str.slice(-2);
      return Number(str)
    },
    handleClear () {
      this.keyword = "";
      this.handleSearch();
    },
    handleSearch () {
      this.pageNo = 1;
      this.getCustomerListAll();
    },
    handleLoad () {

    },
    // 选中
    handleClick (item) {
      this.$store.dispatch("setSelectCustomerForSave", item.name)
      sessionStorage.setItem("selectCustomerForSave", JSON.stringify(item))
      this.$emit("change", item)
    },
    // 获取用户
    getCustomerListAll () {
      let param = {
        name: this.keyword,
      }
      this.loading = true;
        getCustomerInfoPage(param).then((res) => {
        let list = res.data.records || [];
        this.list = list;
        this.finished = true;
        this.loading = false;
      }).catch((err) => {
        console.log(err);
        let msg = err.msg || "网络异常"
        this.$toast(msg)
        this.loading = false;
      });
    },
  }
}
</script>
<style lang="scss" scoped>
.customer-list {
  position: relative;
  background: #fff;
  height: 100%;
  overflow-y: auto;
  padding-top: 2rem;
}

.van-search {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
}

.van-list {
  height: 100%;
  overflow-y: auto;
}
</style>